module.exports = __webpack_public_path__ + "static/media/shards-dashboards-logo.2ae3ab32.svg";